import { Box, List, ListItem, SxProps, Theme, Typography } from '@mui/material';

import { ROIHorizonStrings } from './roiMethodConfig';

type ROIHorizonModalContentProps = Readonly<{
  strings: ROIHorizonStrings;
}>;

export const ROIHorizonModalContent = ({ strings }: ROIHorizonModalContentProps) => {
  return (
    <Box sx={containerSx}>
      {/* What it is */}
      <Box sx={sectionSx}>
        <Typography variant="text-sm-bold">{strings.whatItIs.title}</Typography>
        {strings.whatItIs.paragraphs.map((paragraph, index) => (
          <Typography key={index} variant="text-sm-regular" sx={paragraphSx}>
            {paragraph}
          </Typography>
        ))}
      </Box>

      {/* Why it matters */}
      <Box sx={sectionSx}>
        <Typography variant="text-sm-bold">{strings.whyItMatters.title}</Typography>
        {strings.whyItMatters.paragraphs.map((paragraph, index) => (
          <Typography key={index} variant="text-sm-regular" sx={paragraphSx}>
            {paragraph}
          </Typography>
        ))}
        <List sx={bulletListSx}>
          {strings.whyItMatters.bulletPoints.map((point, index) => (
            <ListItem key={index} sx={bulletItemSx}>
              <Typography variant="text-sm-regular">{point}</Typography>
            </ListItem>
          ))}
        </List>
        <Typography variant="text-sm-regular" sx={paragraphSx}>
          {strings.whyItMatters.additionalParagraph}
        </Typography>
      </Box>

      {/* How it is calculated */}
      <Box sx={sectionSx}>
        <Typography variant="text-sm-bold">{strings.howItIsCalculated.title}</Typography>
        {strings.howItIsCalculated.paragraphs.map((paragraph, index) => (
          <Typography key={index} variant="text-sm-regular" sx={paragraphSx}>
            {paragraph}
          </Typography>
        ))}
        <List sx={bulletListSx}>
          {strings.howItIsCalculated.bulletPoints.map((point, index) => (
            <ListItem key={index} sx={bulletItemSx}>
              <Typography variant="text-sm-regular">{point}</Typography>
            </ListItem>
          ))}
        </List>
        <Typography variant="text-sm-regular" sx={paragraphSx}>
          {strings.howItIsCalculated.conclusion}
        </Typography>
        <Typography variant="text-sm-regular" sx={paragraphSx}>
          {strings.howItIsCalculated.source}
        </Typography>
      </Box>
    </Box>
  );
};

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-lg'],
});

const sectionSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-xs'],
});

const paragraphSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-secondary'],
});

const bulletListSx: SxProps<Theme> = ({ backrs }) => ({
  margin: 0,
  paddingLeft: backrs.spacing['spacing-2xl'],
  listStyleType: 'disc',
});

const bulletItemSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'list-item',
  padding: 0,
  paddingLeft: backrs.spacing['spacing-xs'],
  color: backrs.colors['Colors/Text/text-secondary'],
});
